import { Map } from 'mapbox-gl';
import { mapColorPalette } from "../../../../../constants/Map";
import { ZoomLevel } from "../../../../../store/wellWaterSystem";
import { IWaterSystemGeoBlocks } from '../../../../../types';

export const updateGeoBlockGroupStyles = (
    mapRef: React.RefObject<Map>,
    waterSystemGeoBlocks: IWaterSystemGeoBlocks[] | null,
    geoBlocksGroupUnitsRef: React.MutableRefObject<IWaterSystemGeoBlocks[] | null>,
    zoomLevel: ZoomLevel | string
  ): void => {
    if (!Array.isArray(waterSystemGeoBlocks) || 
        zoomLevel !== ZoomLevel.COUNTY || 
        !mapRef.current?.isStyleLoaded()) {
      return;
    } 

    geoBlocksGroupUnitsRef.current = waterSystemGeoBlocks;
    
    const geojsonData = {
      type: 'FeatureCollection',
      features: waterSystemGeoBlocks.map(block => ({
        type: 'Feature',
        geometry: block.geometry,
        properties: {
          name: block.GEOID_BlkGrp  
        }
      }))
    };
  
    const source = mapRef.current.getSource('main');
    if (source) {
      (source as mapboxgl.GeoJSONSource).setData(geojsonData as any);
    }
  
    const blockColorMapping = waterSystemGeoBlocks.reduce<Record<string, string>>((acc, block, index) => {
      if (!block?.GEOID_BlkGrp) return acc;
      acc[block.GEOID_BlkGrp] = mapColorPalette[index % mapColorPalette.length] || '#d1d1d1';
      return acc;
    }, {});

    mapRef.current.setPaintProperty('main', 'fill-color', [
      'match',
      ['get', 'name'],  
      ...(Object.entries(blockColorMapping).length > 0 
        ? Object.entries(blockColorMapping).flat() 
        : ['', '#fff']),
      '#fff',
    ]);
  };